import { ISocialInstitution } from '../../../interfaces';
import privateHttpClient from '../privateHttpClient';
import { urlHttpGov } from '../../urls';
import SocialInstitutionMapper from '../mappers/SocialInstitutionMapper';
import AppUserMapper from '../mappers/AppUserMapper';

class SocialInstitutionService {
    private baseURL: string = `${urlHttpGov}/panel/social-institution`;

    async list(cityId: number, signal?: AbortSignal): Promise<ISocialInstitution[]> {

        const { data } = await privateHttpClient.get(`${this.baseURL}/county/${cityId}`, { signal });

        return data.map((SocialInstitution: any) => SocialInstitutionMapper.toDomain(SocialInstitution));
    }

    async listAppUsers({ socialInstitutionId, signal }: { socialInstitutionId: number, signal: AbortSignal }) {

        const { data } = await privateHttpClient.get(`${this.baseURL}/users/${socialInstitutionId}`, { signal });

        return data.map((user: any) => AppUserMapper.toDomain(user));
    }


    async getById(id: number, signal: AbortSignal) {
        const { data } = await privateHttpClient.get(`${this.baseURL}/${id}`, { signal });

        return SocialInstitutionMapper.toDomain(data);
    }

    async create({ countyId, cnpj, name, active }: { countyId: number, cnpj: string, name: string, active?: boolean }) {
        const { data } = await privateHttpClient.post(`${this.baseURL}/county/${countyId}`, { cnpj, name, active });

        const domainData = SocialInstitutionMapper.toDomain(data);

        return domainData;
    }

    async update({ id, data }: { id: number, data: ISocialInstitution }) {

        const persistenceData = SocialInstitutionMapper.toPersistence(data);

        return privateHttpClient.put(`${this.baseURL}/${id}`, persistenceData);
    }

    async delete(id: number) {
        return privateHttpClient.delete(`${this.baseURL}/${id}`);
    }


}

// eslint-disable-next-line import/no-anonymous-default-export
export default new SocialInstitutionService();
